import React, { useEffect, useState } from 'react';
import { BrowserRouter as Router, Route, Routes, useLocation } from 'react-router-dom';
import SunnySoftware from './components/SunnySoftware';
import './index.css';

// Wrapper component to handle route changes
const SunnySoftwareWrapper = ({ initialPage }) => {
  const location = useLocation();
  const [currentPage, setCurrentPage] = useState(initialPage || 'landing');
  
  useEffect(() => {
    // Update page when location changes
    const path = location.pathname;
    if (path === '/') {
      setCurrentPage('landing');
    } else {
      setCurrentPage(path.substring(1)); // Remove leading slash
    }
  }, [location.pathname]);
  
  return (
    <SunnySoftware 
      initialPage={currentPage} 
      key={currentPage} // Force re-render when page changes
    />
  );
};

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<SunnySoftwareWrapper />} />
        <Route path="/quitsnus" element={<SunnySoftwareWrapper initialPage="quitsnus" />} />
        <Route path="/mrpiggy" element={<SunnySoftwareWrapper initialPage="mrpiggy" />} />
        <Route path="/quitsmoking" element={<SunnySoftwareWrapper initialPage="quitsmoking" />} />
        <Route path="/nero-diamante" element={<SunnySoftwareWrapper initialPage="nero-diamante" />} />
        
        {/* QuitSnus Privacy and Terms */}
        <Route path="/quitsnus-privacy" element={<SunnySoftwareWrapper initialPage="quitsnus-privacy" />} />
        <Route path="/quitsnus-terms" element={<SunnySoftwareWrapper initialPage="quitsnus-terms" />} />
        
        {/* Mr Piggy Privacy and Terms */}
        <Route path="/mrpiggy-privacy" element={<SunnySoftwareWrapper initialPage="mrpiggy-privacy" />} />
        <Route path="/mrpiggy-terms" element={<SunnySoftwareWrapper initialPage="mrpiggy-terms" />} />
        
        {/* QuitSmoking Privacy and Terms */}
        <Route path="/quitsmoking-privacy" element={<SunnySoftwareWrapper initialPage="quitsmoking-privacy" />} />
        <Route path="/quitsmoking-terms" element={<SunnySoftwareWrapper initialPage="quitsmoking-terms" />} />
        
        {/* Nero Diamante Privacy and Terms */}
        <Route path="/nero-diamante-privacy" element={<SunnySoftwareWrapper initialPage="nero-diamante-privacy" />} />
        <Route path="/nero-diamante-terms" element={<SunnySoftwareWrapper initialPage="nero-diamante-terms" />} />
      </Routes>
    </Router>
  );
}

export default App;